import React from 'react';
const VatContext = React.createContext();
export default VatContext;
